import * as Yup from "yup";

export const dataModel = {
  dateInit: "",
  dateEnd: "",
  status: "",
  userUuid: "",
  viveroUuid: "",
  articleUuid: "",
  batch: "",
  locationUuid: "",
  taskUuid: "",
};

export const validationDataModel = Yup.object().shape({
  dateInit: Yup.date().optional("forms.validations.required"),
  dateEnd: Yup.date().optional("forms.validations.required"),
  status: Yup.string().optional(""),
  userUuid: Yup.string().optional(""),
  viveroUuid: Yup.string().optional(""),
  articleUuid: Yup.string().optional(""),
  batch: Yup.string().optional(""),
  locationUuid: Yup.string().optional(""),
  taskUuid: Yup.string().optional(""),
});

export const setInitialValues = (initialValues) => {
  const newValues = { ...dataModel };
  if (initialValues) {
    const items = Object.keys(newValues);
    items.forEach((item) => {
      if (initialValues[item]) {
        newValues[item] = initialValues[item];
      }
    });
    return newValues;
  }

  return dataModel;
};
